import { Settings } from 'assets/assetsV1/iconComponents';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';

export const ManageViewsHeader = () => (
  <ListItemComp title="Manage your views" LeftComponent={Settings} withoutBackground padding="16px 24px" />
);
